// extracted by mini-css-extract-plugin
module.exports = {"container":"QPbanner_container__pnT7I","content":"QPbanner_content___3q8R","text":"QPbanner_text__lo5bQ"};